import { render } from "./Marquee.vue?vue&type=template&id=1c54cd47&scoped=true"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=1c54cd47&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c54cd47"

export default script